import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Links from './Links';
import Footer from '../Footer';
import Header from '../Header';

import { userMenu, BIMPage } from '../../../Constants/user';
import { bimPageText } from '../../../Constants';

import './style.scss';
import axios from "axios";

class Bim extends PureComponent {
    constructor(props) {
        super(props);
        let firstLang = props.lang || 'arm';
        props.active(2);

        document.title = 'BIM';

        let language = BIMPage.find(el => el.lang === firstLang);

        this.state = {
            language,
            links: {},
            lang: props.lang,
            initialized: false,
        };
    }

    async componentDidMount() {
        try {
            const { data: { status, data } } = await axios.post('/api/bim/getYoutubeLinks');

            if (status) {
                this.setState({
                    links: data,
                    initialized: true,
                });
            }
        } catch (e) {
            console.log(e)
        }
    }

    static getDerivedStateFromProps(props, state) {
        let language = BIMPage.find(el => el.lang === props.lang);

        return {
            ...state,
            language,
            lang: props.lang,
        }
    }

    render() {
        const { language: { question }, initialized, links } = this.state;

        if (!initialized) return null;

        const { setLanguage, language, activeMenu, width } = this.props;

        return (
            <div id={'bimPage'}>
                <div id={'left'}>
                    {width > 1024 ? (
                        <Link to={'/'}><img src={'/images/userPage/desktop/Logo for web.png'} alt="" /></Link>
                    ) : (
                        <Link to={'/'}><img src={'/images/userPage/tablet/Logo2.png'} alt="" /></Link>
                    )}
                </div>
                <div id={'right'}>
                    <Header
                        userMenu={userMenu}
                        language={language}
                        active={activeMenu}
                        setLanguage={setLanguage}
                    />
                    <div id={'container'}>
                        <div id={'containerInner'}>
                            <div id={'textPart'}>
                                <div id={'questionLine'}>
                                    <div id={'question'} dangerouslySetInnerHTML={{__html: question}} />
                                </div>
                                <div className={'videos'}>
                                    {Object.keys(links).map(lang => (
                                        <>
                                            <div className="title">
                                                {bimPageText.find(text => text.lang === lang).language}
                                            </div>
                                            <Links
                                                key={lang}
                                                data={links[lang]}
                                            />
                                        </>
                                    ))}
                                </div>
                            </div>
                            <Footer language={language} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ main: { width } }) => ({
    width,
});

export default connect(mapStateToProps)(Bim);
